import { useState } from "react";
import { PlayerType, MemberType, TeamType, PositionType } from "../../Type/TeamType";
import { AssetSettingModalType, StateType, HeroDataType, ExtensionDataType, ModeType, OpenProps, UpdateMemberProps, DirectionType, ArtSkillDataType, FilterRarityType, EffectSkilePositionType } from "./AssetSettingModalType";

const makeInitialMember = (): MemberType => {
    return {
        hero: {
            agi: 118,
            hp: 459,
            id: 5001,
            int: 96,
            name: "織田信長",
            passive: "天下布武",
            phy: 185,
            rarity: 5,
            trigger: "自分がActive Skillを使用した後、25%の確率で発動"
        },
        leftExtension: {
            agi: 0,
            effect: "[先頭の敵のHPに、自分のPHYの70%~80%分ダメージ,自分のPHYを、自分のPHYの10%分アップ]",
            hp: 117,
            id: 5001,
            int: 0,
            name: "MCHブレード",
            phy: 113,
            rarity: 5,
            skill: "英雄の一撃",
        },
        rightExtension: {
            agi: 0,
            effect: "[先頭の敵のHPに、自分のPHYの70%~80%分ダメージ,自分のPHYを、自分のPHYの10%分アップ]",
            hp: 117,
            id: 5001,
            int: 0,
            name: "MCHブレード",
            phy: 113,
            rarity: 5,
            skill: "英雄の一撃",
        },
        artSkill: {
            effect: "自分のHPを、回復係数の20%分回復",
            id: 9001,
            name: "休む",
            skill: "休む",
        },
        effectSkilePositionTop: "ExtensionLeft",
        effectSkilePositionCenter: "ExtensionRight",
        effectSkilePositionBottom: "ArtSkill",
    }
}


type Props = {
    initialAttackTeam: TeamType | null,
    initialDefenceTeam: TeamType | null,
}

export const useAssetSettingModal = ({
    initialAttackTeam,
    initialDefenceTeam
}: Props): AssetSettingModalType => {
    const [state, setState] = useState<StateType>(
        {
            isOpen: false,
            mode: "Hero",
            player: "Attack",
            position: "FRONT",
            filterRarity: "None",
            isAuto: false
        }
    );
    const [attackTeam, setAttackTeam] = useState<TeamType>(
        initialAttackTeam ? initialAttackTeam :
            {
                front: makeInitialMember(),
                middle: makeInitialMember(),
                back: makeInitialMember(),
            }
    );
    const [defenceTeam, setDefenceTeam] = useState<TeamType>(
        initialDefenceTeam ? initialDefenceTeam :
            {
                front: makeInitialMember(),
                middle: makeInitialMember(),
                back: makeInitialMember(),
            }
    );

    const setMode = (mode: ModeType) => {
        setState(
            {
                ...state,
                mode: mode
            }
        );
    }

    const getSelectedTeamMember = (): MemberType => {
        const selectedTeam = state.player === "Attack" ? attackTeam : defenceTeam;
        switch (state.position) {
            case "FRONT":
                return selectedTeam.front
            case "MIDDLE":
                return selectedTeam.middle
            case "BACK":
                return selectedTeam.back
        }
    }

    const updateTeamMemberHeroData = (hero: HeroDataType) => {
        const selectedTeamMember = getSelectedTeamMember()
        updateTeamMember({
            ...selectedTeamMember,
            hero: hero
        })
    }

    const updateTeamMemberExtensionData = (direction: DirectionType, extension: ExtensionDataType) => {
        const selectedTeamMember = getSelectedTeamMember()
        switch (direction) {
            case "Left":
                return updateTeamMember({
                    ...selectedTeamMember,
                    leftExtension: extension
                })
            case "Right":
                return updateTeamMember({
                    ...selectedTeamMember,
                    rightExtension: extension
                })
        }
    }
    const updateTeamMemberArtSkillData = (artSkill: ArtSkillDataType) => {
        const selectedTeamMember = getSelectedTeamMember()
        updateTeamMember({
            ...selectedTeamMember,
            artSkill: artSkill
        })
    }

    const updateTeamMember = (member: MemberType) => {
        return updateMember(
            {
                setTeam: state.player === "Attack" ? setAttackTeam : setDefenceTeam,
                position: state.position,
                member
            }
        );
    }

    const updateMember = ({ setTeam, position, member }: UpdateMemberProps) => {
        switch (position) {
            case "FRONT":
                return setTeam((preTeam) => {
                    return {
                        ...preTeam,
                        front: member
                    }
                });
            case "MIDDLE":
                return setTeam((preTeam) => {
                    return {
                        ...preTeam,
                        middle: member
                    }
                });
            case "BACK":
                return setTeam((preTeam) => {
                    return {
                        ...preTeam,
                        back: member
                    }
                });
        }
    };

    const setNextStateMode = (mode: ModeType) => {
        setState(
            {
                ...state,
                position: "FRONT",
                mode: mode
            }
        );
    }
    const nextStateMode = () => {
        switch (state.mode) {
            case "Hero":
                return setNextStateMode('ExtensionLeft');
            case 'ExtensionLeft':
            case 'ExtensionRight':
                return setNextStateMode("ArtSkill");
            default:
                return setNextStateMode('Hero');
        }
    }
    const backStateMode = () => {
        switch (state.mode) {
            case "ArtSkill":
                return setMode("ExtensionRight");
            case 'ExtensionLeft':
            case 'ExtensionRight':
                return setMode("Hero");
            default:
                return setMode("Hero");
        }
    }
    const setExtensionMode = (extensionMode: "ExtensionLeft" | "ExtensionRight") => {
        setMode(extensionMode);
    }

    const open = ({ mode, player, position, isAuto = false }: OpenProps) => setState(
        {
            ...state,
            isOpen: true,
            mode: mode || state.mode,
            player: player || state.player,
            position: position || state.position,
            isAuto: isAuto,
            filterRarity: "None"
        }
    )

    const close = () => setState(
        {
            ...state,
            isOpen: false
        }
    );

    const onSelectStatePosition = (position: PositionType) => {
        setState(
            {
                ...state,
                // TODO リファクタリング
                mode: state.mode === "ExtensionRight" ? "ExtensionLeft" : state.mode,
                position: position
            }
        );
    }

    const onSelectStateFilterRarity = (rarity: FilterRarityType) => {
        setState(
            {
                ...state,
                mode: state.mode === "ExtensionRight" ? "ExtensionRight" : state.mode,
                filterRarity: rarity
            }
        );
    }

    const onSelectStateModeAndPosition = (mode: ModeType, position: PositionType, isAuto = false) => {
        setState(
            {
                ...state,
                mode: mode,
                position: position,
                isAuto: isAuto
            }
        );
    }

    const defenceTeamSelect = () => {
        setState(
            {
                ...state,
                player: "Defence",
                mode: "Hero",
                position: "FRONT",
                isAuto: true
            }
        );
    }

    const switchingTeam = () => {
        // TODO コストーパフォーマンスなどの問題があれば修正
        setAttackTeam(defenceTeam)
        setDefenceTeam(attackTeam)
    }

    const switchingStatePlayer = () => setState(
        {
            ...state,
            player: state.player === "Attack" ? "Defence" : "Attack"
        }
    )

    const getAttackTeamMember = (position: PositionType): MemberType => {
        switch (position) {
            case "FRONT":
                return attackTeam.front
            case "MIDDLE":
                return attackTeam.middle
            case "BACK":
                return attackTeam.back
        }
    }

    const getDefenceTeamMember = (position: PositionType): MemberType => {
        switch (position) {
            case "FRONT":
                return defenceTeam.front
            case "MIDDLE":
                return defenceTeam.middle
            case "BACK":
                return defenceTeam.back
        }
    }

    const setEffectSkilePositionTop = (player: PlayerType, position: PositionType) => {
        const member = player === "Attack" ? getAttackTeamMember(position) : getDefenceTeamMember(position)
        if (player === "Attack") {
            switch (position) {
                case "FRONT":
                    return setAttackTeam(
                        {
                            ...attackTeam,
                            front: {
                                ...member,
                                effectSkilePositionTop: member.effectSkilePositionCenter,
                                effectSkilePositionCenter: member.effectSkilePositionTop,
                            }
                        }
                    )
                case "MIDDLE":
                    return setAttackTeam(
                        {
                            ...attackTeam,
                            middle: {
                                ...member,
                                effectSkilePositionTop: member.effectSkilePositionCenter,
                                effectSkilePositionCenter: member.effectSkilePositionTop,
                            }
                        }
                    )
                case "BACK":
                    return setAttackTeam(
                        {
                            ...attackTeam,
                            back: {
                                ...member,
                                effectSkilePositionTop: member.effectSkilePositionCenter,
                                effectSkilePositionCenter: member.effectSkilePositionTop,
                            }
                        }
                    )
            }
        } else {
            switch (position) {
                case "FRONT":
                    return setDefenceTeam(
                        {
                            ...defenceTeam,
                            front: {
                                ...member,
                                effectSkilePositionTop: member.effectSkilePositionCenter,
                                effectSkilePositionCenter: member.effectSkilePositionTop,
                            }
                        }
                    )
                case "MIDDLE":
                    return setDefenceTeam(
                        {
                            ...defenceTeam,
                            middle: {
                                ...member,
                                effectSkilePositionTop: member.effectSkilePositionCenter,
                                effectSkilePositionCenter: member.effectSkilePositionTop,
                            }
                        }
                    )
                case "BACK":
                    return setDefenceTeam(
                        {
                            ...defenceTeam,
                            back: {
                                ...member,
                                effectSkilePositionTop: member.effectSkilePositionCenter,
                                effectSkilePositionCenter: member.effectSkilePositionTop,
                            }
                        }
                    )
            }
        }
    }

    const setEffectSkilePositionBottom = (player: PlayerType, position: PositionType) => {
        const member = player === "Attack" ? getAttackTeamMember(position) : getDefenceTeamMember(position)
        if (player === "Attack") {
            switch (position) {
                case "FRONT":
                    return setAttackTeam(
                        {
                            ...attackTeam,
                            front: {
                                ...member,
                                effectSkilePositionCenter: member.effectSkilePositionBottom,
                                effectSkilePositionBottom: member.effectSkilePositionCenter,
                            }
                        }
                    )
                case "MIDDLE":
                    return setAttackTeam(
                        {
                            ...attackTeam,
                            middle: {
                                ...member,
                                effectSkilePositionCenter: member.effectSkilePositionBottom,
                                effectSkilePositionBottom: member.effectSkilePositionCenter,
                            }
                        }
                    )
                case "BACK":
                    return setAttackTeam(
                        {
                            ...attackTeam,
                            back: {
                                ...member,
                                effectSkilePositionCenter: member.effectSkilePositionBottom,
                                effectSkilePositionBottom: member.effectSkilePositionCenter,
                            }
                        }
                    )
            }
        } else {
            switch (position) {
                case "FRONT":
                    return setDefenceTeam(
                        {
                            ...defenceTeam,
                            front: {
                                ...member,
                                effectSkilePositionCenter: member.effectSkilePositionBottom,
                                effectSkilePositionBottom: member.effectSkilePositionCenter,
                            }
                        }
                    )
                case "MIDDLE":
                    return setDefenceTeam(
                        {
                            ...defenceTeam,
                            middle: {
                                ...member,
                                effectSkilePositionCenter: member.effectSkilePositionBottom,
                                effectSkilePositionBottom: member.effectSkilePositionCenter,
                            }
                        }
                    )
                case "BACK":
                    return setDefenceTeam(
                        {
                            ...defenceTeam,
                            back: {
                                ...member,
                                effectSkilePositionCenter: member.effectSkilePositionBottom,
                                effectSkilePositionBottom: member.effectSkilePositionCenter,
                            }
                        }
                    )
            }
        }
    }

    return {
        state,
        attackTeam,
        defenceTeam,
        updateTeamMemberHeroData,
        updateTeamMemberExtensionData,
        updateTeamMemberArtSkillData,
        nextStateMode,
        backStateMode,
        setExtensionMode,
        switchingTeam,
        onSelectStatePosition,
        onSelectStateModeAndPosition,
        onSelectStateFilterRarity,
        defenceTeamSelect,
        switchingStatePlayer,
        setEffectSkilePositionTop,
        setEffectSkilePositionBottom,
        open,
        close
    };
};
